export const QA_INSURANCE_CONTEXT = 'insurance'
